import {
  StrictMode
} from "react";
import {
  createRoot
} from "react-dom/client";
import App from "./App";
import "./styles.css";
import "./lib/firebase";

const element =
  document.getElementById("root");

if (!element) {
  throw new Error(
    "Root element was not found."
  );
}

createRoot(element).render(
  <StrictMode>
    <App />
  </StrictMode>
);
